import { Global } from '../../global';
import { UtilityService } from '../../../services/Acc_Utility.service';
import { GL_Category } from '../../../models/GL_Category';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { GL_Master, GL_Master_Save } from '../../../models/GL_Master';
import {GL_MasterService} from '../../../services/Acc_GL_Master.service';
//import { ConsoleReporter } from 'jasmine';

@Component({
  selector: 'app-gl-master-add',
  templateUrl: './gl-master-add.component.html',
  styleUrls: ['./gl-master-add.component.css']
})
export class GlMasterAddComponent implements OnInit {
  ArrLabels: any;
  labels: any = {};

  gl_Master: GL_Master_Save = {
    GL_Code: "",
    GL_Desc: "",
    GL_Desc_en: "",
    GL_CategoryID:1,
    RecordStat:"",
    AuthStat: "",
    MakerID: "",
    CheckerID: "",
    CreateDate: new Date(),
    branchId: 0,
    branchName:""
  };

  //categories: GL_Category[]; 
  categories: any;

  constructor(
    private GL_MasterService:GL_MasterService,
    private UtilityService: UtilityService,
    private global:Global,
    private router: Router ) { 
      
  }

  ngOnInit() {
    this.getCategories();
    this.getLabels();
  }

  getCategories(){
    this.GL_MasterService.getGL_Category()
      .subscribe(response => {
          if (response) {
              this.categories = response;
              console.log(response);
          }
      },
      error => console.log(error))

  }


  submit(){
    this.GL_MasterService.AddGL_Master(this.gl_Master)
    .subscribe( response => {
      if(response)
        this.router.navigate(['/gl_master']);
    },
    error => console.log(error))
  }

  getLabels(){
    this.UtilityService.getLabels('gl-master-add',this.global.lang)
      .subscribe(response => {
          if(response){
              this.ArrLabels = response;
              this.setLabels();
          }
      },
      error => console.log(error))
    }

  setLabels(){

    this.labels['gl-master-add-Title'] = this.ArrLabels.find( (o:any) => o.key === 'gl-master-add-Title').value;
    this.labels['AccountID'] = this.ArrLabels.find( (o:any) => o.key === 'AccountID').value;
    this.labels['AccountName'] = this.ArrLabels.find( (o:any) => o.key === 'AccountName').value;
    this.labels['AccountName_en'] = this.ArrLabels.find( (o:any) => o.key === 'AccountName_en').value;
    this.labels['AccountCategory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountCategory').value;

    // alerts
    this.labels['AccountIDMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountIDMandatory').value;
    this.labels['AccountNameMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountNameMandatory').value;
    this.labels['AccountCategoryMandatory'] = this.ArrLabels.find( (o:any) => o.key === 'AccountCategoryMandatory').value;

    // shared labels.
    this.labels['RecordStat'] = this.ArrLabels.find( (o:any) => o.key === 'RecordStat').value;
    this.labels['AuthStat'] = this.ArrLabels.find( (o:any) => o.key === 'AuthStat').value;
    this.labels['CreateDate'] = this.ArrLabels.find( (o:any) => o.key === 'CreateDate').value;
    this.labels['CheckerID'] = this.ArrLabels.find( (o:any) => o.key === 'CheckerID').value;
    this.labels['MakerID'] = this.ArrLabels.find( (o:any) => o.key === 'MakerID').value;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/GLs/gl-master-add/gl-master-add.component.ts